import { openDB } from "idb";

const DB_NAME = "chambers-diary";
const DB_VERSION = 2;

export const ENTITY_STORES = {
  events: "event_id",
  matters: "matter_id",
  courts: "court_id",
  todos: "todo_id",
  postits: "post_it_id",
  logs: "log_id",
  kits: "event_id",
};

let handle = null;

export const idb = () => {
  if (!handle) {
    handle = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        Object.entries(ENTITY_STORES).forEach(([name, keyPath]) => {
          if (!db.objectStoreNames.contains(name)) db.createObjectStore(name, { keyPath });
        });
        ["kv", "meta"].forEach((name) => {
          if (!db.objectStoreNames.contains(name)) db.createObjectStore(name);
        });
        if (!db.objectStoreNames.contains("conflicts")) {
          db.createObjectStore("conflicts", { keyPath: "id" });
        }
        if (!db.objectStoreNames.contains("queue")) {
          db.createObjectStore("queue", { keyPath: "seq", autoIncrement: true });
        }
      },
    });
  }
  return handle;
};

export const rows = async (store) => {
  try {
    return await (await idb()).getAll(store);
  } catch {
    return [];
  }
};

export const row = async (store, key) => {
  try {
    return await (await idb()).get(store, key);
  } catch {
    return undefined;
  }
};

export const put = async (store, value, key) => {
  try {
    return await (await idb()).put(store, value, key);
  } catch {
    return undefined;
  }
};

export const del = async (store, key) => {
  try {
    return await (await idb()).delete(store, key);
  } catch {
    return undefined;
  }
};

export const putMany = async (store, list) => {
  const clean = (Array.isArray(list) ? list : []).filter(Boolean);
  if (!clean.length) return;
  try {
    const db = await idb();
    const tx = db.transaction(store, "readwrite");
    clean.forEach((item) => tx.store.put(item));
    await tx.done;
  } catch {
    /* cache writes are best effort */
  }
};

export const meta = async (key, fallback = null) => {
  const value = await row("meta", key);
  return value === undefined ? fallback : value;
};

export const setMeta = (key, value) => put("meta", value, key);

export const clearCache = async () => {
  const db = await idb();
  for (const name of [...Object.keys(ENTITY_STORES), "kv"]) {
    try {
      await db.clear(name);
    } catch {
      /* ignore */
    }
  }
  await setMeta("cached_at", null);
  if ("caches" in window) {
    try {
      await caches.delete("diary-attachments-v1");
    } catch {
      /* ignore */
    }
  }
};

/** Offline data belongs to one diary at a time — switching diaries wipes the mirror. */
export const ensureScope = async (workspaceId) => {
  if (!workspaceId) return;
  const current = await meta("scope");
  if (current && current !== workspaceId) await clearCache();
  if (current !== workspaceId) await setMeta("scope", workspaceId);
};
